/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimpleInvestmentCompanyRequest } from './simple-investment-company-request';
import { DeckCreateInvestmentRequestPaymentOption } from './deck-create-investment-request-payment-option';
import { InvestmentStatusEnum } from './investment-status-enum';
import { UserRequest } from './user-request';

export interface PatchedDeckDetailInvestmentRequest {
  id?: string;
  user?: UserRequest;
  investment_company?: SimpleInvestmentCompanyRequest;
  payment_option?: DeckCreateInvestmentRequestPaymentOption | null;
  amount?: string | null;
  status?: InvestmentStatusEnum;
  pitch_name?: string;
  account_number?: string | null;
  vps?: string | null;
  paid?: boolean;
  shares?: number | null;
  declared_shares?: number | null;
  invested_by?: UserRequest;
  compensation?: string | null;
  agreement_idfy_id?: string | null;
}
export namespace PatchedDeckDetailInvestmentRequest {}
